import LabelWithTooltip from "@/components/form/labels/LabelWithTooltip";
import AntIcon from "@/components/icons/AntIcon";
import { skipInitialFormValues } from "@/utils/formUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validations } from "@/utils/validationUtils";
import { Button, Card, Checkbox, Col, Form, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useGetAgentTree } from "../../../../common/api/queries";
import { rowGutter } from "../../../../common/constants";
import { AgentSelect } from "../../../enumerations/components/form/AgentSelect";
import { DEFAULT_FILTER_AGENT_TREE_QUERY_PARAMS } from "../../api";
import { AgentTreeFilterRequest } from "../../types";

type Props = {
  searchParams: AgentTreeFilterRequest;
};

export const AgentTreeFilterForm = ({ searchParams }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isFetching } = useGetAgentTree(searchParams);

  const [form] = Form.useForm<AgentTreeFilterRequest>();

  useEffect(() => {
    form.setFieldsValue(searchParams);
  }, [form]);

  const handleFilterSubmit = (filter: AgentTreeFilterRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: {
            ...filter,
            ...skipInitialFormValues(filter, DEFAULT_FILTER_AGENT_TREE_QUERY_PARAMS),
          },
          append: true,
        }),
      },
      { replace: true },
    );
  };

  return (
    <Card className="card-box" title={<h2>{t("agent.titles.tree")}</h2>}>
      <Form form={form} onFinish={handleFilterSubmit} layout="vertical" name="agentTreeFilterForm">
        <Row gutter={rowGutter} justify="center" align="bottom">
          <Col span={6}>
            <Form.Item
              name="rootAgentId"
              label={
                <LabelWithTooltip tooltip={t("agent.helpers.rootAgentHint")} label={t("agent.filter.rootAgentId")} />
              }
            >
              <AgentSelect allowClear />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              name="includeDeactivated"
              className="form-item-without-label"
              valuePropName="checked"
              rules={[validations.none]}
              initialValue={DEFAULT_FILTER_AGENT_TREE_QUERY_PARAMS.includeDeactivated}
            >
              <Checkbox>{t("agent.filter.includeDeactivated")}</Checkbox>
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              name="includeRepresentatives"
              className="form-item-without-label"
              valuePropName="checked"
              rules={[validations.none]}
              initialValue={DEFAULT_FILTER_AGENT_TREE_QUERY_PARAMS.includeRepresentatives}
            >
              <Checkbox>{t("agent.filter.includeRepresentatives")}</Checkbox>
            </Form.Item>
          </Col>

          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />} loading={isFetching}>
                {t("common.filter")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
